import { Can } from "@/components/citadel";
import { useProject } from "@/hooks/use-project";
import { useResourceLinks } from "@/hooks/use-resource-links";
import { AddResourceLinkModal } from "@/modals/projects/add-resource-link-modal";
import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { TicketFormResourceLinkItem } from "./ticket-form-resource-link-item";

/** Props Interface */
interface TicketFormResourceLinksProps {
	projectId: string;
	ticketId: string;
}

export function TicketFormResourceLinks({ projectId, ticketId }: TicketFormResourceLinksProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Query */
	const { resourceLinks, refetch } = useResourceLinks({ ticketId });
	const { project } = useProject({ projectId });

	/** Render */
	return (
		<div className="v-stack gap-2">
			<div className="h-stack items-center justify-between">
				<p className="label">{t("resource_links.resource_links")}</p>
				<Can
					action="update"
					subject="Project"
					resource={project ? { ...project } : undefined}
				>
					<Button
						size="xxs"
						variant="white"
						icon={<Icon name="Plus" />}
						onClick={disclosure.onOpen}
						data-cy="ticket-add-resource-link-button"
					>
						{t("resource_links.add_resource_link")}
					</Button>
				</Can>
			</div>
			{resourceLinks?.map((resourceLink) => (
				<TicketFormResourceLinkItem
					key={resourceLink.id}
					resourceLink={resourceLink}
					onDeleted={async () => {
						await refetch();
					}}
				/>
			))}
			{disclosure.isOpen && (
				<AddResourceLinkModal
					projectId={projectId}
					ticketId={ticketId}
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={async () => {
						await refetch();
					}}
				/>
			)}
		</div>
	);
}
